import clsx from "clsx"
import { FC } from "react"
import {
  AchievementExplorerImg,
  AchievementFixerImg,
  AchievementMinerImg,
  AchievementStakerImg
} from "@/assets"
import { IUserAchievements, IUserStakingBonus } from "@/store/apis/userAPI"
import styles from "./Achievements.module.scss"
import { AchievementCard } from "./ui"

interface IAchievements {
  achievements: IUserAchievements
  stakingBonus?: IUserStakingBonus
}

export const Achievements: FC<IAchievements> = ({
  achievements,
  stakingBonus
}) => {
  return (
    <div className={clsx(styles.Achievements)}>
      <AchievementCard
        icon={AchievementExplorerImg}
        level={achievements.explorer}
      />
      <AchievementCard icon={AchievementMinerImg} level={achievements.miner} />
      <AchievementCard icon={AchievementFixerImg} level={achievements.fixer} />
      <AchievementCard
        icon={AchievementStakerImg}
        level={stakingBonus?.month ?? 0}
        isStaker
      />
    </div>
  )
}
